import { stringUtils } from '@verifime/utils';
import { TFromFieldInfo, TRules } from '../utils';
import {
  TFormFieldsAndRules as TBaseFormFieldsAndRules,
  getFieldsRules as getFieldsRulesCommon,
  getFieldsNamesFromFieldsAndRules as getFieldsNamesFromFieldsAndRulesCommon,
  getFieldInfoByFieldName as getFieldInfoByFieldNameCommon,
  markFieldsReadonly as markFieldsReadonlyCommon,
} from '../common';

export { fieldComponentMapping } from '../common';

export type TFormFieldsAndRulesRow<T = any> = {
  fields: TFromFieldInfo<T>[];
  RowContainer?: React.ComponentType<{ children: React.ReactNode }>;
};

export type TFormFieldsAndRules<TFieldName = string> = {
  [rows: string]: TFormFieldsAndRulesRow<TFieldName>;
};

function convertToBaseFormFieldsAndRules<TFieldName = string>(
  formFieldsAndRules: TFormFieldsAndRules<TFieldName>,
): TBaseFormFieldsAndRules<TFieldName> {
  return Object.entries(formFieldsAndRules).reduce((acc, [rowKey, rowValue]) => {
    acc[rowKey] = rowValue.fields;
    return acc;
  }, {} as TBaseFormFieldsAndRules<TFieldName>);
}

export function getFieldsRules<TFieldName = string>(
  formFieldsAndRules?: TFormFieldsAndRules<TFieldName>,
  prefix?: keyof typeof formFieldsAndRules,
): TRules {
  // TODO: processing prefix situation ?

  return getFieldsRulesCommon(convertToBaseFormFieldsAndRules(formFieldsAndRules), prefix);
}

export function getFieldsNamesFromFieldsAndRules(
  formFieldsAndRules?: TFormFieldsAndRules,
): string[] {
  return getFieldsNamesFromFieldsAndRulesCommon(
    convertToBaseFormFieldsAndRules(formFieldsAndRules),
  );
}

export function getFieldInfoByFieldName(
  fieldsAndRules: TFormFieldsAndRules,
  fieldName: string,
): TFromFieldInfo {
  return getFieldInfoByFieldNameCommon(convertToBaseFormFieldsAndRules(fieldsAndRules), fieldName);
}

/**
 *
 * Mark fields of `formFieldsAndRules` readonly once the fields name included by `readonlyFieldsName`
 */
export function markFieldsReadonly(
  formFieldsAndRules: TFormFieldsAndRules,
  readonlyFieldsName: string[] = [],
) {
  markFieldsReadonlyCommon(convertToBaseFormFieldsAndRules(formFieldsAndRules), readonlyFieldsName);
}
